import { render, staticRenderFns } from "./CreateNewMember1.vue?vue&type=template&id=a3136cba"
import script from "./CreateNewMember1.vue?vue&type=script&lang=js"
export * from "./CreateNewMember1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports